export default "__VITE_PUBLIC_ASSET__15ad88a1__"